
let routes = [
    {
        path: '/wxvue/TEST',
        component: resolve => require(['./pages/activity/TEST.vue'], resolve),
        name: '',
        hidden: true
    },

    //begin热门课程
    {
        path: '/wxvue/orderlessonlist',
        component: resolve => require(['./pages/my/order/OrderLesson_list.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotlessoncar',
        component: resolve => require(['./pages/course/HotLessonCar.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/successlesson',
        component: resolve => require(['./pages/SuccessLesson.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotlessoncheck',
        component: resolve => require(['./pages/course/HotLessonCheck.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotlessonenroll',
        component: resolve => require(['./pages/course/HotLessonEnroll.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotlessonimgs',
        component: resolve => require(['./pages/course/HotLessonImgs.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotlessonevaluate',
        component: resolve => require(['./pages/course/HotLessonEvaluate.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotlessondetail',
        component: resolve => require(['./pages/course/HotLessonDetail.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotlessonbox',
        component: resolve => require(['./pages/course/HotLessonBox.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotlesson',
        component: resolve => require(['./pages/course/HotLesson.vue'], resolve),
        name: '',
        hidden: true
    },


    //end热门课程
    {
        path: '/wxvue/orderevaluatewx',
        component: resolve => require(['./pages//my/order/OrderEvaluateWx.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/myfollow',
        component: resolve => require(['./pages/activity/MyFollow.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/activityqareply',
        component: resolve => require(['./pages/activity/ActivityQareply.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/orderevaluatesuccess',
        component: resolve => require(['./pages//my/order/OrderEvaluatesuccess.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/activityimgs',
        component: resolve => require(['./pages/activity/ActivityImgs.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/activitycheck',
        component: resolve => require(['./pages/activity/ActivityCheck.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/successactivity',
        component: resolve => require(['./pages/SuccessActivity.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/orderenrollinfo',
        component: resolve => require(['./pages/my/order/OrderEnrollInfo.vue'], resolve),
        name: '',
        hidden: true
    },

    {
        path: '/wxvue/orderevaluate',
        component: resolve => require(['./pages/my/order/OrderEvaluate.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/activityqadetail',
        component: resolve => require(['./pages/activity/ActivityQadetail.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/activityqalist',
        component: resolve => require(['./pages/activity/ActivityQalist.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/activityevaluate',
        component: resolve => require(['./pages/activity/ActivityEvaluate.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/activitypayment',
        component: resolve => require(['./pages/activity/ActivityPayment.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/activityenroll',
        component: resolve => require(['./pages/activity/ActivityEnroll.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/activityinfo',
        component: resolve => require(['./pages/activity/ActivityInfo.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/activitydetail',
        component: resolve => require(['./pages/activity/ActivityDetail.vue'], resolve),
        name: '',
        hidden: true
    },

    {
        path: '/wxvue/communityqyqmap',
        component: resolve => require(['./pages/community/Community-qyq-map.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communitylqyqmap',
        component: resolve => require(['./pages/community/Community-lqyq-map.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/votemain',
        component: resolve => require(['./pages/vote/VoteMain.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/votelist',
        component: resolve => require(['./pages/vote/VoteList.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/mycollect',
        component: resolve => require(['./pages/my/Mycollect.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/myfamily',
        component: resolve => require(['./pages/my/Myfamily.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/addfamily',
        component: resolve => require(['./pages/my/Addfamily.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/editfamily',
        component: resolve => require(['./pages/my/Editfamily.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/login',
        component: resolve => require(['./pages/Login.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/register',
        component: resolve => require(['./pages/Register.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/resetpassword',
        component: resolve => require(['./pages/Reset-password.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/editpersonal',
        component: resolve => require(['./pages/my/Editpersonal.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/public',
        component: resolve => require(['./pages/Public.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/iseeenroll',
        component: resolve => require(['./pages/bditem/isee/IseeEnroll.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/iseesuccess',
        component: resolve => require(['./pages/bditem/isee/IseeSuccess.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/msj',
        component: resolve => require(['./pages/bditem/museum-school-jinsha/Msj_imgpage.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/bdhpm',
        component: resolve => require(['./pages/bditem/bdhelper/BdhPayment.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/bdhinfo',
        component: resolve => require(['./pages/bditem/bdhelper/BdhInfo.vue'], resolve),
        name: '',
        hidden: true
    },
  {
    path: '/wxvue/yx',
    component: resolve => require(['./pages/bditem/bdhelper/yx.vue'], resolve),
    name: '',
    hidden: true
  },
    {
        path: '/wxvue/bdhenroll',
        component: resolve => require(['./pages/bditem/bdhelper/BdhEnroll.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/scansign',
        component: resolve => require(['./pages/bditem/scansign/ScanSign.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/community',
        component: resolve => require(['./pages/community/Community.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communityApp',
        component: resolve => require(['./pages/community/Community-app.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communitylist',
        component: resolve => require(['./pages/community/Community-list.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communityThemeType',
        component: resolve => require(['./pages/community/Community-theme-type.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communitysearchlist',
        component: resolve => require(['./pages/community/Community-search-list.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communityThemeList',
        component: resolve => require(['./pages/community/Community-theme-list.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communityThemeDetaile',
        component: resolve => require(['./pages/community/Community-theme-detaile.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communitypublicdetaile',
        component: resolve => require(['./pages/community/Community-public-detaile.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communitydetaile',
        component: resolve => require(['./pages/community/Community-detaile.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communityedulist',
        component: resolve => require(['./pages/community/Community-edu-list.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communityedudetaile',
        component: resolve => require(['./pages/community/Community-edu-detaile.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communitycheck',
        component: resolve => require(['./pages/community/Community-check.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communityenroll',
        component: resolve => require(['./pages/community/Community-enroll.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communityannouncement',
        component: resolve => require(['./pages/community/Community-announcement.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/communitymap',
        component: resolve => require(['./pages/community/Community-map.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/announcementdetaile',
        component: resolve => require(['./pages/community/Announcement-detaile.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/outschool',
        component: resolve => require(['./pages/outschool/Outschool.vue'],resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/outlovelist',
        component: resolve => require(['./pages/outschool/Outschool-love-list.vue'],resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/outlovelist1',
        component: resolve => require(['./pages/outschool/Outschool-love-list1.vue'],resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/outsearchlist',
        component: resolve => require(['./pages/outschool/Outschool-search-list.vue'],resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/outlovedetaile',
        component: resolve => require(['./pages/outschool/Outschool-love-detaile.vue'],resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/outlovedetaile1',
        component: resolve => require(['./pages/outschool/Outschool-love-detaile1.vue'],resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/outenroll',
        component: resolve => require(['./pages/outschool/Outschool-love-enroll.vue'],resolve),
        component: resolve => require(['./pages/outschool/Outschool-love-enroll.vue'],resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/newslist',
        component: resolve => require(['./pages/outschool/Outschool-news-list.vue'],resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/newsdetaile',
        component: resolve => require(['./pages/outschool/Outschool-news-detaile.vue'],resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/orderlist',
        component: resolve => require(['./pages/my/order/Order-list.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/orderdetaile',
        component: resolve => require(['./pages/my/order/Order-detaile.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/beerskittles',
        component: resolve => require(['./pages/activity/BeerSkittles.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotactivity',
        component: resolve => require(['./pages/activity/HotActivity.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotdetail',
        component: resolve => require(['./pages/activity/HotDetail.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotcheck',
        component: resolve => require(['./pages/activity/HotCheck.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotcourse',
        component: resolve => require(['./pages/course/HotCourse.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotcoursedetaile',
        component: resolve => require(['./pages/course/HotCourseDetail.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/hotcoursecheck',
        component: resolve => require(['./pages/course/HotCourseCheck.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/mymain',
        component: resolve => require(['./pages/my/MyMain.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/success',
        component: resolve => require(['./pages/Success.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/success_bdh',
        component: resolve => require(['./pages/Success_bdh.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/telbind',
        component: resolve => require(['./pages/Telbind.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/applink',
        component: resolve => require(['./pages/Applink.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/404',
        component: resolve => require(['./pages/404.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/wxvue/*',
        hidden: true,
        redirect: {path: '/404'}
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js